import { LayoutDashboard, Building2, Users, Layers, GitBranch, Network, Settings,UserCheck2 } from 'lucide-react';

export const ADMIN_NAV_ITEMS = [
  { id: 'dashboard',  label: 'Overview',                    icon: LayoutDashboard, path: '/admin' },
  { id: 'companies',  label: 'Companies',                   icon: Building2,       path: '/admin/companies' },
  { id: 'users',      label: 'User Management',             icon: Users,           path: '/admin/users' },
  { id: 'workspaces', label: 'Workspaces',                  icon: Layers,          path: '/admin/workspaces' },
  { id: 'workspaceMapping', label: 'Workspace Mapping',     icon: GitBranch,       path: '/admin/workspace-mapping' },
  { id: 'data',       label: 'Data Sources & Integrations', icon: Network,         path: '/admin/data' },
  { id: 'settings',   label: 'System Settings',             icon: Settings,        path: '/admin/settings' },
  { id: 'usermodelgroupmapping', label: 'User Model Group Mapping', icon: UserCheck2,      path: '/admin/usermodelgroupmapping' },
];
